import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import WigOrderList from '../components/WigOrders/WigOrderList';
import ViewWigOrder from '../components/WigOrders/ViewWigOrder';
import EditWigOrder from '../components/WigOrders/EditWigOrder';

const WigOrders = () => {
  return (
    <Routes>
      <Route path="/" element={<WigOrderList />} />
      <Route path="/edit/:id" element={<EditWigOrder />} />
      <Route path="/edit" element={<EditWigOrder />} />
      <Route path="/view/:id" element={<ViewWigOrder />} />
    </Routes>
  )
}

export default WigOrders;